import * as Yup from 'yup';
import { PqrData } from '../../../../../../shared/types/modules/pqr';

export const initialValues: PqrData = {
    branch: '',
    receptionChannel: '',
    type: '',
    half: '',
    subtypeDp: '',
    procedure: '',
};

export const validationSchema = Yup.object({
    branch: Yup.string().required(
        'El área y/o sucursal de expedición es obligatorio'
    ),
    receptionChannel: Yup.string().required(
        'El canal de recepción es obligatorio'
    ),
    type: Yup.string().required('El tipo de PQR es obligatorio'),
    half: Yup.string().required('El medio es obligatorio'),
    subtypeDp: Yup.string().required('El subtipo DP es obligatorio'),
    procedure: Yup.string().required('El trámite es obligatorio'),
});
